// @flow

import { SearchSimilarLink } from 'src/Domain/Fallback/SearchSimilarLink';
import { SupportLink } from 'src/Domain/Fallback/SupportLink';
import { TransferButton } from 'src/Domain/Fallback/TransferButton';
import { WhoisLink } from 'src/Domain/Fallback/WhoisLink';
import { Unavailable } from 'src/Domain/Unavailable';

import type { ExtendedResult } from '../types';

import {
  getDomainPossibility,
  renewPossibility2AvailabilityIconName,
  useAvailabilityText,
} from './modules';

type Props = { result: ExtendedResult };

export function UnavailableRow({ result }: Props): React.MixedElement {
  const availabilityText = useAvailabilityText({ domain: result });

  const possibility = getDomainPossibility(result);
  const availabilityIconName =
    renewPossibility2AvailabilityIconName[possibility];

  return (
    <Unavailable
      availabilityIconName={availabilityIconName}
      availabilityText={availabilityText}
      fqdn={result.fqdn}
    >
      {['notAtGandi', 'unavailable'].includes(possibility) && (
        <WhoisLink fqdn={result.fqdn} />
      )}
      {['invalid', 'unavailable'].includes(possibility) && (
        <SearchSimilarLink term={result.fqdn} />
      )}
      {possibility === 'error' && <SupportLink />}
      {possibility === 'transferable' && <TransferButton fqdn={result.fqdn} />}
    </Unavailable>
  );
}

UnavailableRow.Error = function UnavailableRowError({
  fqdn,
}: {
  fqdn: string,
}): React.MixedElement {
  return <Unavailable.Error fqdn={fqdn} />;
};
